import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from '../home/home.component';
import {NgModule} from '@angular/core';
import { SubmissionDetailsComponent } from "../submission-details/submission-details.component";
import { Angulartics2Module, Angulartics2GoogleAnalytics } from 'angulartics2';
import { DonationComponent } from "../donation/donation.component";

const routes: Routes = [
    {path: '' , component: HomeComponent },
    {path: 's/:id', component: SubmissionDetailsComponent},
    {path: 'donate', component: DonationComponent }
]

@NgModule({
    imports: [
        RouterModule.forRoot(routes),
        Angulartics2Module.forRoot([Angulartics2GoogleAnalytics])
    ],
    exports: [RouterModule]
})

export class AppRoutingModule {}


// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/app/core/app-routing.module.ts